import { Theme, } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => {
  return {
    appBar: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
    },
    menu: {
      display: 'flex',
      alignContent: 'space-between',
    },
    menuItem: {
      padding: theme.spacing(2, 3),
      color: theme.palette.common.black,
      paddingLeft: '13px',
      paddingRight: '13px',
    },
    countrySelector: {
      marginTop: '10px',
    },
    headerSpacer: {
      height: '50px',
    },
    container: {
      padding: '12px',
      maxWidth: '500px'
    }
  }
});

export default useStyles;
